import {
  CIVILBUDGET_LOADING,
  GET_CIVILBUDGET,
  GET_CIVILBUDGET_SUCCESS,
  GET_CIVILBUDGET_FAIL,
  ADD_CIVILBUDGET_SUCCESS,
  ADD_CIVILBUDGET_FAIL,
  DELETE_CIVILBUDGET_SUCCESS,
  DELETE_CIVILBUDGET_FAIL,
  UPDATE_CIVILBUDGET_SUCCESS,
  UPDATE_CIVILBUDGET_FAIL,
  CIVILBUDGET_RESET
} from "./actionType";

const INIT_STATE = {
  civilBudgets: [],
  error: {},
};

const CivilBudget = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CIVILBUDGET_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGET:
          return {
            ...state,
            civilBudgets: action.payload.data,
            isCivilBudgetCreated: false,
            isCivilBudgetSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CIVILBUDGET_FAIL:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGET_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCivilBudgetCreated: false,
            isCivilBudgetSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CIVILBUDGET: {
      return {
        ...state,
        isCivilBudgetCreated: false,
        loading: true,
      };
    }

    case CIVILBUDGET_LOADING: {
      return {
        ...state,
        isCivilBudgetCreated: false,
        loading: true,
      };
    }

    case ADD_CIVILBUDGET_SUCCESS:
      return {
        ...state,
        isCivilBudgetCreated: true,
        loading: false,
        civilBudgets: [action.payload.data, ...state.civilBudgets],
      };

    case ADD_CIVILBUDGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CIVILBUDGET_SUCCESS:
      return {
        ...state,
        loading: false,
        civilBudgets: state.civilBudgets.filter(
          civilCivilBudget => civilCivilBudget.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CIVILBUDGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CIVILBUDGET_SUCCESS:
      return {
        ...state,
        loading: false,
        civilBudgets: state.civilBudgets.map(civilCivilBudget =>
          civilCivilBudget.id.toString() === action.payload.data.id.toString() ? { ...civilCivilBudget, ...action.payload.data } : civilCivilBudget
        ),
      };

    case UPDATE_CIVILBUDGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CIVILBUDGET_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CivilBudget;